import _ from 'lodash';
import { connect } from 'react-redux';
import { search, remove } from '../../modules/ocr/ocrGuide';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	let ocrGuides;
	if (state.lists.ocrGuideIds) {
		ocrGuides = _.map(state.lists.ocrGuideIds, (id) => state.maps.ocrGuide[id]);
	}
	return {
		ocrGuides,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		carrierMap: state.maps.carrier,
		supplierMap: state.maps.supplier,
		terminalMap: state.maps.terminal,
		resourceMap: state.maps.resource,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			ocrGuideSearch: search,
			ocrGuideRemove: remove,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
